import React from 'react';

import { coalesceGet } from 'dpl/shared/utils/object';
import GenericPodcastEmbed from 'dpl/prismic/components/PodcastEmbed';
import { ArticlePropTypes } from 'dpl/prismic/utils/customPropTypes';

import { ARTICLE_CONTENT_COL_CLASSES } from '../utils/constants';

export default function PodcastEmbed({ article }) {
  const url = coalesceGet(article, [
    'data.podcast_embed.url',
    'data.podcast_embed.embed_url'
  ]);

  if (!url) {
    return null;
  }

  return (
    <div className="PrismicArticlePodcastEmbed container">
      <div className="row">
        <div className={ARTICLE_CONTENT_COL_CLASSES}>
          <GenericPodcastEmbed url={url} />
        </div>
      </div>
    </div>
  );
}

PodcastEmbed.propTypes = {
  article: ArticlePropTypes.isRequired
};
